import { createContext, useReducer, useContext, ReactNode } from 'react';
import { IVariableAction, IVariableContext } from '../types';
import { tsThemeVars } from '../data';

const VariableContext = createContext<IVariableContext | undefined>(undefined);

function variableReducer(state: any, action: any): any {
  switch (action.type) {
    case 'updatedState': {
      const releaseVariables = action?.value?.variables || tsThemeVars;
      return { ...releaseVariables };
    }
    // move this from here for V2 , whyyyy do we have like this :cry:
    case 'updateStyleState': {
      const newState = { ...state, [action.value.key]: action.value.value };
      return { ...newState };
    }
    case 'updateLiveboardList': {
      return { ...state, liveboardList: action.value };
    }

    case 'updateLiveboardVizList': {
      return { ...state, liveboardVizList: action.value };
    }

    case 'updateDataSourceList': {
      return { ...state, dataSourceList: action.value };
    }

    case 'updateAnswerList': {
      return { ...state, answerList: action.value };
    }

    default: {
      throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
  }
}

function VariableProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(variableReducer, initialVariables);

  const value = { state, dispatch };
  return <VariableContext.Provider value={value}>{children}</VariableContext.Provider>;
}

function useVariable(): IVariableContext {
  const context = useContext(VariableContext);
  if (context === undefined) {
    throw new Error('useVariable must be used within a VariableProvider');
  }
  return context;
}

export { VariableProvider, useVariable };

type TsCssVariable = keyof typeof tsThemeVars;

const removeDefaultValue = (vars: Record<TsCssVariable, string>) => {
  const newVars = { ...vars };
  for (const key in newVars) {
    newVars[key] = 'initial';
  }
  return newVars;
};

const initialVariables: Record<TsCssVariable, string> = removeDefaultValue({
  ...(tsThemeVars || {}),
});
